import React from 'react';
import { PreparationSection, ResultsSection, MeasurementsSection } from './Sections';
import ids from '../QestIds';

const qestIds = [ids.specificGravityCoarse.AASHTO_T_85.rev2014, ids.specificGravityCoarse.ASTM_C_127.rev2015];

let MeasuredSpecificGravityCoarseWorksheet = () => (
  <>
    <PreparationSection />
    <MeasurementsSection restrictToOnePortion />
    <ResultsSection />
  </>
);

MeasuredSpecificGravityCoarseWorksheet.qestIds = qestIds;

export default MeasuredSpecificGravityCoarseWorksheet;
export { MeasuredSpecificGravityCoarseWorksheet };
